<template>
  <div class="tax-que" :class="`tax-que-${mode}`">
    <!-- 做题 -->
    <div class="que-input-wrap" :class="{ 'is-error': isShowError }" v-if="[1, 2, 3, 5].includes(mode)">
      <slot name="input"></slot>
    </div>
    <!-- 考题 -->
    <div class="que-score-wrap" v-if="[2, 4].includes(mode)">
      <template v-if="data.hasOwnProperty('score')">
        <slot name="score"></slot>
      </template>
    </div>
  </div>
</template>

<script setup>
import Big from "big.js";
// mode
// 1 做题（做题√ 答案× 学员数据）
// 2 答案与分值管理（做题√ 答案√ 老师数据）
// 3 查看结果（做题√ 答案× 学员数据）
// 4 查看答案（做题× 答案√（隐藏分数） 老师数据）
// 5 初始数据（做题√ 答案× 学员数据）
const props = defineProps({
  data: {
    type: Object,
    require: true,
    default: () => {},
  },
  mode: {
    type: Number,
    require: true,
  },
});

const isShowError = computed(() => {
  if (props.mode != 3) {
    return false;
  }

  const { value, answer, score } = props.data;

  try {
    if (answer == null || score == null) {
      return false;
    }

    if (value == answer) {
      return false;
    }

    if (String(value) == String(answer)) {
      return false;
    }

    if (new Big(value).eq(answer)) {
      return false;
    }
  } catch (e) {
    console.log(e);
    return true;
  }

  return true;
});
</script>

<style lang="scss" scoped>
.tax-que {
  &.tax-que-4 {
    :deep(.score-wrap-score) {
      display: none;
    }
  }

  .que-input-wrap {
    &.is-error {
      padding: 6px;
      box-shadow: 0 0 1px 2px #f96a6a inset;
    }
  }

  .que-score-wrap {
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    flex-direction: column;
    padding: 6px;
    box-shadow: 0 0 1px 2px #009b45 inset;

    > * {
      width: 100% !important;
    }

    :deep(.score-wrap-score) {
      margin-top: 6px !important;

      input {
        color: #ff4242 !important;
      }
    }
  }
}
</style>
